/* eslint-disable no-unused-expressions */
// const { language } = window
import AOS from 'aos';

const widthDesktop = 1200;

AOS.init();

// import SnapSlider from '@tannerhodges/snap-slider';

// const slider = new SnapSlider('#slider')
export function hiddenCategoryBlogWrap() {
  const itemsList = document.getElementById('itemsList');
  const toggleBtn = document.getElementById('toggleBtn');
  if (!itemsList || !toggleBtn) return;

  const items = itemsList.querySelectorAll('.un-blog-category-wrap__el');

  function getVisibleCount() {
    return 768 >= window.innerWidth ? 4 : 8;
  }

  function setCollapsedHeight() {
    if (0 < items.length) {
      const itemHeight = items[0].offsetHeight;
      const visibleCount = getVisibleCount();
      itemsList.style.setProperty('--collapsed-height', `${itemHeight * visibleCount + 60}px`);
    }
  }

  setCollapsedHeight();
  window.addEventListener('resize', setCollapsedHeight);

  toggleBtn.addEventListener('click', e => {
    e.stopPropagation();
    itemsList.classList.toggle('collapsed');
    itemsList.classList.toggle('expanded');
  });

  itemsList.addEventListener('click', e => {
    if (!toggleBtn.contains(e.target)) {
      e.stopPropagation();
    }
  });

  document.addEventListener('click', e => {
    if (!itemsList.contains(e.target)) {
      if (itemsList.classList.contains('expanded')) {
        itemsList.classList.remove('expanded');
        itemsList.classList.add('collapsed');
      }
    }
  });
}
export function generateTextAnchors() {
  const contentAnchors = [...document.querySelectorAll('.js-content-anchor')]
  const content = document.getElementById('post-content')
  if (!contentAnchors || !content) return;
  const headings = [...content.querySelectorAll('h2')]
  if (!headings) return
  contentAnchors.forEach(anchor => {
    anchor.addEventListener('click', e => {
      e.preventDefault()

      const anchorText = anchor.textContent
        .trim().replace(/^\d+\.\s*/, '')

      const head = headings.find(h => {
        const headText = h.textContent.trim().replace(/^\d+\.\s*/, '')
        return headText === anchorText
      })

      if (head) {
        const isMobile = 768 > window.innerWidth
        const offset = isMobile ? 60 : 100
        const topPos = head.getBoundingClientRect().top + window.scrollY - offset

        window.scrollTo({
          top: topPos,
          behavior: 'smooth',
        })
      }
    })
  })
}

export function checkLogo() {}
export function unAddStickyProductTabs() {
  const header = document.getElementById('header-wrap');
  const tabsWrap = document.getElementsByClassName('un-tabs-wrap')[0];
  const breadcrumbs = document.getElementsByClassName('un-breadcrumbs-wrap')[0];

  if (!header || !tabsWrap) return;

  let headerHeight = header.offsetHeight;
  if (breadcrumbs) {
    headerHeight += breadcrumbs.offsetHeight
  }
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY >= headerHeight) {
      tabsWrap.classList.add('sticky-active');
    } else {
      tabsWrap.classList.remove('sticky-active');
    }
  });
}
// export function unCheckWidthCategoryMain() {
//   if (widthDesktop >= window.innerWidth) return;
//   const wrap = document.getElementsByClassName('un-main-container')[0];
//   if (!wrap) return;
//
//   const el = wrap.getElementsByClassName('category-swipe-wrapper')[0];
//   const container = document.getElementsByClassName('g-container')[0];
//
//   if (!el || !container) return;
//
//   const containerWidth = container.offsetWidth;
//   const screenWidth = window.innerWidth;
//
//   const offsetPx = Math.max((screenWidth - containerWidth) / 2, 0);
//
//   el.style.width = `calc(100% - ${offsetPx}px)`;
// }
// window.addEventListener('resize', unCheckWidthCategoryMain);

export function unFatMenuPosition() {
  if (widthDesktop >= window.innerWidth) return;
  const fatMenu = document.getElementById('fat-menu');
  const header = document.getElementById('header-wrap');
  const [headerTopEl] = [...document.getElementsByClassName('un-header_top')]
  const marquees = [...document.getElementsByClassName('marquee')].map(e => e.offsetHeight).reduce((a, b) => a + b, 0);

  if (!fatMenu || !header) return;

  function checkPositions() {
    const headerTop = header.getBoundingClientRect().top + window.scrollY;
    const isHeaderAtTop = (40 + marquees) === Math.round(headerTop);
    if (!isHeaderAtTop) {
      fatMenu.style.setProperty('--offset', `${header.offsetHeight}px`)
      fatMenu.style.position = 'fixed';
    } else {
      fatMenu.style.setProperty('--offset', `${header.offsetHeight + headerTopEl.offsetHeight + marquees}px`)
      fatMenu.style.position = 'fixed';
      // fatMenu.style.top = '';
    }
  }

  window.addEventListener('scroll', checkPositions);
  window.addEventListener('resize', checkPositions);
}
export function unSimpleAccardion() {
  let isMobile = null;
  let listeners = [];

  function destroyAccordion() {
    listeners.forEach(({ header, handler }) => {
      header.removeEventListener('click', handler);
    });
    listeners = [];
    document.querySelectorAll('.un-accordion-footer__content').forEach(content => {
      content.classList.remove('active');
    });
    document.querySelectorAll('.un-accordion-footer__icon').forEach(icon => {
      icon.classList.remove('rotated');
    });
  }

  function initAccordion() {
    if (768 < window.innerWidth) {
      if (false !== isMobile) {
        destroyAccordion();
        isMobile = false;
      }
      return;
    }

    if (true === isMobile) return;

    destroyAccordion();
    isMobile = true;

    const accordions = document.querySelectorAll('.un-accordion-footer');
    accordions.forEach(accordion => {
      const header = accordion.querySelector('.un-accordion-footer__header');
      const content = accordion.querySelector('.un-accordion-footer__content');
      const icon = accordion.querySelector('.un-accordion-footer__icon');

      const handler = () => {
        content.classList.toggle('active');
        icon.classList.toggle('rotated');
      };

      header.addEventListener('click', handler);
      listeners.push({ header, handler });
    });
  }

  window.addEventListener('load', initAccordion);
  window.addEventListener('resize', () => {
    initAccordion();
  });
}

export function checkAndCreateDots() {
  const sliders = document.querySelectorAll('[data-snap-slider]');

  sliders.forEach(slider => {
    const sliderId = slider.getAttribute('data-snap-slider');

    const slides = slider.querySelectorAll('.un-best-sellers-view, .best-sellers-view, .un-last_view');
    const dotsContainer = document.querySelector(`[data-slider-dots="${sliderId}"]`);
    if (!slider || 0 === slides.length || !dotsContainer) return;

    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('un-slider-dot');
      if (0 === index) dot.classList.add('active');

      dot.addEventListener('click', () => {
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start' });
      });

      dotsContainer.appendChild(dot);
    });

    slider.addEventListener('scroll', () => {
      let closestIndex = 0;
      let minDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - slider.getBoundingClientRect().left);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      dotsContainer.querySelectorAll('.un-slider-dot').forEach((dot, index) => {
        dot.classList.toggle('active', index === closestIndex);
      });
    });
  });
}
export function checkAndCreateDotsBlueBar() {
  const sliders = document.querySelectorAll('[data-snap-slider-bar]');

  sliders.forEach(slider => {
    const sliderId = slider.getAttribute('data-snap-slider-bar');

    let dotsContainer;

    const parentContainer = slider.closest('.slider-box');
    if (parentContainer) {
      dotsContainer = parentContainer.querySelector(`[data-slider-dots-bar="${sliderId}"]`);
    }

    if (!dotsContainer) {
      const allDotsContainers = document.querySelectorAll(`[data-slider-dots-bar="${sliderId}"]`);
      const allSliders = document.querySelectorAll(`[data-snap-slider-bar="${sliderId}"]`);
      const sliderIndex = Array.from(allSliders).indexOf(slider);
      dotsContainer = allDotsContainers[sliderIndex];
    }

    const progressBar = dotsContainer?.querySelector('.un-slider-progress');

    if (!slider || !dotsContainer || !progressBar) return;

    const isScrollable = slider.scrollWidth > slider.clientWidth;
    dotsContainer.style.display = isScrollable ? 'block' : 'none';
    if (!isScrollable) return;

    const updateProgress = () => {
      const { scrollLeft } = slider;
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const progressPercent = 0 === maxScrollLeft ? 0 : (scrollLeft / maxScrollLeft) * 100;
      progressBar.style.width = `${progressPercent}%`;
    };

    updateProgress();

    slider.removeEventListener('scroll', updateProgress);
    slider.addEventListener('scroll', updateProgress);
  });
}

export function checkHeightTextSize() {
  if (768 >= window.innerWidth) return;
  const textBlocks = document.getElementsByClassName('js-helpers-text');
  const imageBlocks = document.getElementsByClassName('js-helpers-image');
  if (!textBlocks && !imageBlocks) return
  for (let i = 0; i < textBlocks.length && i < imageBlocks.length; i++) {
    imageBlocks[i].style.height = `${textBlocks[i].offsetHeight }px`;
  }
}
export function simpleReadMore() {
  document.querySelectorAll('.un-text-container-js').forEach(container => {
    const content = container.querySelector('.un-text-content-js');
    const button = container.querySelector('.un-read-more-btn-js');
    const fullText = content.textContent.trim();
    const maxLength = parseInt(container.getAttribute('data-maxlength'), 10);
    if (fullText.length <= maxLength) {
      button.classList.add('hidden');
      return;
    }

    const shortText = `${fullText.slice(0, maxLength) }...`;
    let expanded = false;
    content.textContent = shortText;

    button.classList.remove('hidden');
    button.textContent = window.unhidden;

    button.addEventListener('click', () => {
      expanded = !expanded;
      content.textContent = expanded ? fullText : shortText;
      button.textContent = expanded ? window.hiddens : window.unhidden;
    });
  });
}
export function unAddScrollWrap(wrapClass, scrollClass) {
  const wrapList = document.getElementsByClassName(wrapClass);
  const wrap = 0 < wrapList.length ? wrapList[0] : null;
  if (!wrap) return;

  const elList = wrap.getElementsByClassName(scrollClass);
  const el = 0 < elList.length ? elList[0] : null;
  if (!el) return;

  // el.addEventListener('wheel', e => {
  //   if (0 === e.deltaY) return;
  //   e.preventDefault();
  //   el.scrollLeft += e.deltaY;
  // });

  el.addEventListener('mouseenter', () => {
    el.classList.add('show-scrollbar');
  });

  el.addEventListener('mouseleave', () => {
    el.classList.remove('show-scrollbar');
  });
}

const hoverFn = (child, timeout) => {
  window.mounseover_timeout = setTimeout(() => {
    const overlay = document.getElementById('menu-overlay')
    const menu = document.getElementById('fat-menu')
    const triggers = Array.from(document.getElementsByClassName('un-catalog-btn'))
    triggers.forEach(b => b.classList.add('is-opened'))
    menu.classList.add('is-active')
    menu.classList.add('is-hovered')
    overlay.classList.remove('is-hidden')
    // eslint-disable-next-line no-underscore-dangle
    window.app.__vue__.getMenu()
  }, timeout)
}

export function imitateHover() {
  const parent = document.getElementById('desktop-hover')
  const timeout = 700
  if (!parent) return
  parent.addEventListener('mouseenter', () => {
    hoverFn(parent, timeout)
  })
  parent.addEventListener('mouseleave', () => {
    clearTimeout(window.mounseover_timeout)
  })
}

export function mobileFlipper() {
  const cards = Array.from(document.getElementsByClassName('flip-container'))
  cards.forEach(el => {
    el.addEventListener('click', () => {
      cards.forEach(card => card.classList.remove('hover'))
      el.classList.add('hover')
    })
  })
}
export function antiMobileFlipper(e) {
  if ('string' === typeof e.target.className && e.target.className.includes('category-card')) return
  const cards = Array.from(document.getElementsByClassName('flip-container'))
  cards.forEach(card => card.classList.remove('hover'))
}

export function prettyMobHeader() {
  const header = document.getElementById('header-wrap')
  const offset = 60
  if (!header) return
  const scrollHeader = () => {
    if (document.body.scrollTop > offset ||
      document.documentElement.scrollTop > offset) {
      header.classList.add('is-active')
      return false
    }
    header.classList.remove('is-active')
    return false
  }
  window.addEventListener('scroll', scrollHeader, { passive: true })
}

function scrollFunction() {
  const btnScroll = document.getElementById('scroll-top')
  const offset = 60
  if (document.body.scrollTop > offset ||
    document.documentElement.scrollTop > offset) {
    btnScroll.classList.add('is-active')
  } else {
    btnScroll.classList.remove('is-active')
  }
}

export const scrolly = () => {
  // Scroll to Up
  scrollFunction()
  window.addEventListener('scroll', scrollFunction, { passive: true })
}

export function themeAccordions() {
  const [parent] = document.getElementsByClassName('answers-block')
  if (!parent) return
  const themes = [...parent.getElementsByClassName('theme-link')]
  themes.forEach(theme => {
    theme.addEventListener('click', () => {
      const answers = [...parent.getElementsByClassName('js-answers')]
      // eslint-disable-next-line no-unused-vars
      const child = answers.find(el => el.dataset.id === theme.dataset.id)
    })
  })
}

export function changeSellerText() {
  const sellerBtns = [...document.getElementsByClassName('js-seller-link')]
  const [sellerText] = [...document.getElementsByClassName('js-seller-text')]
  const [firstBtn] = sellerBtns
  if (!sellerBtns || !sellerText) return
  sellerBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sellerText.innerHTML = btn.dataset.text
      sellerBtns.forEach(item => {
        item !== btn ? item.classList.remove('is-active') : item.classList.add('is-active')
      })
    })
  })
  firstBtn.dispatchEvent(new Event('click'))
}
